export default __webpack_public_path__ + "static/media/033.86db97a7.webp";